export class TrackerFileFilter {
    terminalId?: number;
    initialDate?: Date;
    finalDate?: Date;
    sourceDevice?: string;
    fileType?: string;
    sourceEvents?: string[];
}
